// i18n调试工具 - 找出有问题的翻译key

export function debugI18n(i18n) {
  console.log('=== 开始i18n诊断 ===')
  
  const messages = i18n.global.messages.value || i18n.global.messages
  const locale = i18n.global.locale.value || i18n.global.locale
  
  console.log('当前语言:', locale)
  console.log('可用语言:', Object.keys(messages))
  
  // 遍历所有消息，尝试编译每一个
  const checkMessages = (msgs, lang, path = '') => {
    const errors = []
    
    for (const [key, value] of Object.entries(msgs)) {
      const fullPath = path ? `${path}.${key}` : key
      
      if (typeof value === 'string') {
        // 尝试使用这个翻译
        try {
          // 检查特殊字符
          if (value.includes('@:')) {
            console.warn(`链接引用 @ ${lang}.${fullPath}: "${value}"`)
          }
          if (value.includes('|')) {
            console.warn(`管道符 | ${lang}.${fullPath}: "${value}"`)
          }
          if (value.match(/\{[^}]*\}/)) {
            console.warn(`变量插值 {} ${lang}.${fullPath}: "${value}"`)
          }
          
          // 尝试翻译
          const result = i18n.global.t(fullPath)
          if (result === fullPath) {
            console.warn(`翻译失败 ${lang}.${fullPath}`)
          }
        } catch (e) {
          errors.push({
            path: fullPath,
            value: value,
            error: e.message
          })
          console.error(`!!! 错误 ${lang}.${fullPath}:`, e.message)
        }
      } else if (typeof value === 'object' && value !== null) {
        // 递归检查
        const subErrors = checkMessages(value, lang, fullPath)
        errors.push(...subErrors)
      }
    }
    
    return errors
  }
  
  // 检查每种语言
  for (const [lang, msgs] of Object.entries(messages)) {
    console.log(`\n检查语言: ${lang}`)
    const errors = checkMessages(msgs, lang)
    
    if (errors.length > 0) {
      console.error(`!!! ${lang} 发现 ${errors.length} 个错误:`)
      errors.forEach(err => {
        console.error(`  - ${err.path}: ${err.error}`)
        console.error(`    内容: "${err.value.substring(0, 50)}..."`)
      })
    } else {
      console.log(`✓ ${lang} 没有发现错误`)
    }
  }
  
  console.log('=== i18n诊断完成 ===')
}

// 创建一个安全的t函数包装器
export function createSafeT(originalT) {
  return (key, ...args) => {
    try {
      return originalT(key, ...args)
    } catch (error) {
      console.error(`翻译错误 key="${key}":`, error.message)
      // 返回key作为fallback
      return key
    }
  }
}